import React from 'react'
import { Box, Divider, Typography, Skeleton } from '@mui/material'

import { AppLinearProgress, AppOfficesBlock } from '@components'
import { truncateString } from '@utils'


export default function AppReportSearchesOfficesModalBlock({ isLoading, officesData }) {

	if (isLoading) return <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 1.5, width: '50%' }}>
		<Skeleton variant="rectangular" height={60} width="100%"/>
		<Skeleton variant="rectangular" height={270} width="100%"/>
	</Box>

	const { completedPercentage, totalPercentage, officesInfo } = officesData

	return <Box sx={{ width: '50%' }}>
		<Typography variant="subtitle1">
			Searches by Offices
		</Typography>
		<AppLinearProgress actual={completedPercentage} total={totalPercentage} highlighted/>

		<Divider sx={{ my: 3 }}/>

		<Box sx={{ maxHeight: '30vh', overflowY: 'auto', p: 1 }}>
			{officesInfo?.map(({ name, country, type, current, total }, idx) => !!total &&
				<Box key={idx} sx={{
					display: 'flex',
					width: 1,
					mb: .5,
					gap: 1,
				}}>
					<AppOfficesBlock
						name={truncateString(name, 22)}
						country={country}
						type={type}
						variant="body1"
						sx={{ textWrap: 'nowrap', minWidth: 200 }}
					/>
					<AppLinearProgress actual={current} total={total} color="info"/>
				</Box>)}
		</Box>
	</Box>
}